/*
 * @Author: XCL
 * @Date: 2015-11-23
 * @LastEditTime : 2019-12-25 19:16:02
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\editingCenter\app\preview\previewRouter.js
 * @Description:
 */
'use strict';
angular.module('appPreviewRouterModule', ['versionModule', 'initPreviewBtnsModule', 'appPreviewModule']).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('appPreview', {
            url: '/apppreview?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&appdoctype&isawaitrevise&fromsearch&takedraft', // TakeDraft 图集稿件模式下判断是否需要取稿
            views: {
                '': {
                    templateUrl: './editingCenter/app/preview/appPreview_tpl.html',
                    controller: 'appPreviewCtrl',
                },
            },
        });
    },
]);
